import { Gauge, Waves, Video, Crosshair } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";
import { IMG } from "@/lib/site";

const specs = [
  { icon: Gauge, label: "5000 PSI jetting head", color: "#adff01" },
  { icon: Waves, label: "High-pressure specialised hose", color: "#ff66c4" },
  { icon: Video, label: "CCTV camera inspection", color: "#169ed9" },
  { icon: Crosshair, label: "Precision locating equipment", color: "#ffffff" },
];

export default function Equipment() {
  return (
    <section id="equipment" data-testid="equipment-section" className="relative overflow-hidden border-b-2 border-white/10 py-24 md:py-32">
      <span
        aria-hidden="true"
        className="text-outline pointer-events-none absolute -top-6 right-0 select-none font-display text-[22vw] uppercase leading-none opacity-40"
      >
        5000
      </span>
      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <SectionTag number="03" label="The Arsenal" color="#169ed9" />

        <div className="grid gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <div
              className="shadow-hard-azure relative border-2 border-white/15"
              data-testid="equipment-image-frame"
            >
              <img
                src={IMG.jetter}
                alt="5000 PSI high-pressure drain jetting equipment"
                className="h-72 w-full object-cover md:h-[28rem]"
                loading="lazy"
              />
              <span className="absolute left-4 top-4 border-2 border-black bg-[#adff01] px-3 py-1 font-display text-xs uppercase tracking-widest text-black">
                The Beast
              </span>
            </div>
          </Reveal>

          <div className="flex flex-col justify-center lg:col-span-5">
            <Reveal>
              <h2 className="font-display text-4xl uppercase leading-[0.9] tracking-tight sm:text-5xl">
                Meet the{" "}
                <span className="text-[#169ed9]">5000 PSI</span> jetter.
              </h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-6 text-base leading-relaxed text-zinc-300 md:text-lg">
              <p data-testid="equipment-copy">
                We arrive onsite with everything loaded and ready to go. No "we'll have to
                come back with the right gear" — the gear is the point. It cuts roots,
                clears heavy blockages and scrubs your pipework clean.
              </p>
            </Reveal>
            <ul className="mt-8 space-y-3">
              {specs.map(({ icon: Icon, label, color }, i) => (
                <Reveal key={label} delay={0.15 + i * 0.08}>
                  <li
                    className="flex items-center gap-3 border-2 border-white/10 bg-[#121214] px-4 py-3 text-sm font-bold uppercase tracking-wider text-zinc-200"
                    data-testid={`equipment-spec-${i}`}
                  >
                    <Icon className="h-5 w-5 shrink-0" style={{ color }} strokeWidth={2.5} />
                    {label}
                  </li>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
